<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="list-product p-2">
        <lib-crud
          [newLabel]="'Add Supplier'"
          [items]="SupplierList"
          (actionHandler)="handleEvent($event)"
          (deleteActionHandler)="deleteRecord($event)"
          [closePopup]="closeFormEvent"
          [openEditPopup]="editRecord"
          [popupWidthPercent]="'55'"
          [openDeletePopup]="openDeletePopup"
        >
          <form class="row" formsElement #SupplierForm="ngForm">
            
            <!-- Supplier Details -->
            <h5 class="mt-3 mb-2">Supplier Details</h5>

            <hr style="margin-top: 10px;">

            <div class="col-md-4">
              <label for="companyName">Company Name</label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                class="form-control"
                [(ngModel)]="Supplier.companyName"
                
              />
            </div>

            <div class="col-md-4">
              <label for="contactPerson">Supplier Name</label>
              <input
                type="text"
                id="contactPerson"
                name="contactPerson"
                class="form-control"
                [(ngModel)]="Supplier.contactPerson"
                
              />
            </div>

            <div class="col-md-4">
              <label for="phoneNumber">Phone Number</label>
              <input
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                class="form-control"
                [(ngModel)]="Supplier.phoneNumber"
                
              />
            </div>

            <div class="col-md-4">
              <label for="emailAddress">Email Address</label>
              <input
                type="email"
                id="emailAddress"
                name="emailAddress"
                class="form-control"
                [(ngModel)]="Supplier.emailAddress"
              />
            </div>

            <div class="col-md-12">
              <label for="address">Address</label>
              <textarea
                id="address"
                name="address"
                rows="3"
                class="form-control"
                [(ngModel)]="Supplier.address"
                
              ></textarea>
            </div>

            <h5 class="mt-3 mb-2">Tax & Payment Details</h5>
<hr style="margin-top: 10px;">

<div class="col-md-4">
  <label for="gstNumber">GST Number</label>
  <input
    type="text"
    id="gstNumber"
    name="gstNumber"
    class="form-control"
    [(ngModel)]="Supplier.gstNumber"
   
  />
</div>

<div class="col-md-4">
  <label for="panNumber">PAN Number</label>
  <input
    type="text"
    id="panNumber"
    name="panNumber"
    class="form-control"
    [(ngModel)]="Supplier.panNumber"
   
  />
</div>

<div class="col-md-4">
  <label for="bankAccountNumber">Bank Account Number</label>
  <input
    type="text"
    id="bankAccountNumber"
    name="bankAccountNumber"
    class="form-control"
    [(ngModel)]="Supplier.bankAccountNumber"
   
  />
</div>

<div class="col-md-4">
  <label for="bankName">Bank Name</label>
  <input
    type="text"
    id="bankName"
    name="bankName"
    class="form-control"
    [(ngModel)]="Supplier.bankName"
   
  />
</div>

<div class="col-md-4">
  <label for="ifscCode">IFSC Code</label>
  <input
    type="text"
    id="ifscCode"
    name="ifscCode"
    class="form-control"
    [(ngModel)]="Supplier.ifscCode"
   
  />
</div>

<div class="col-md-4">
  <label for="upiId">UPI ID</label>
  <input
    type="text"
    id="upiId"
    name="upiId"
    class="form-control"
    [(ngModel)]="Supplier.upiId"
  />
</div>

          </form>

          <div class="row" footerButtons>
            <div class="col-md-12 text-end">
              <button
                class="btn btn-outline-primary me-2"
                [disabled]="SupplierForm.invalid"
                (click)="processSupplier()"
              >
                <i class="pi pi-check"></i>
                {{ Supplier.id ? "Update" : "Add" }} Supplier
              </button>
              <button
                class="btn btn-outline-primary"
                (click)="closeForm()"
              >
                <i class="pi pi-times"></i> Cancel
              </button>
            </div>
          </div>
        </lib-crud>
      </div>
    </div>
  </div>
</div>
